module.exports = __webpack_public_path__ + "img/160x130.db6d2389.png";